/* Views */
// const StyleGuide = () => import('../pages/StyleGuide.vue')
const Wizard = () => import(/* webpackChunkName: 'wizardvue' */ '../pages/Wizard')
const ThankYouPage = () => import(/* webpackChunkName: 'thankyouvue' */ '../pages/ThankYou')

/* Localized routes */
const LOCALIZED_ROUTES = {
  'en-GB': 'online-booking',
  'de-DE': 'online-buchung',
  'it-IT': 'prenotazione-online',
  'fr-FR': 'reservation-en-ligne'
}

/* Router configuration */
const childRoutesPerLocale = (locale) => [
  {
    path: '',
    meta: { guest: true },
    component: Wizard,
  },

  {
    path: 'thank-you',
    name: `thank-you__${locale}`,
    component: ThankYouPage
  },

  // {
  //   path: 'style-guide',
  //   meta: { guest: true },
  //   component: StyleGuide,
  // },

  { path: '*', redirect: '' }
]

export default Object.entries(LOCALIZED_ROUTES)
  .map(([locale, route]) => ({
    path: `/:lang/${route}`,
    component: { render: c => c('router-view') },
    children: childRoutesPerLocale(locale)
  })
)
